import React, { useState } from 'react';
import useAuth from '../../hooks/useAuth';
import { Link, useNavigate } from 'react-router-dom';
import { Eye, EyeOff, User } from "lucide-react";
import GradientButton from '../../components/GradientButton/GradientButton';

import './Login.css';

const Login = () => {
  const navigate = useNavigate();
  const { handleLogin } = useAuth();
  const [error, setError] = useState('');
  const [credentials, setCredentials] = useState({ username: '', password: '' });
  const [showPassword, setShowPassword] = useState(false);
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await handleLogin(credentials);
      navigate('/dashboard');
    } catch (error) {
      setError('Login fallido');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="login-page flex h-screen items-center justify-center bg-gray-100 px-4"
      style={{ backgroundImage: `url(${process.env.PUBLIC_URL}/nebulox_login_bg.png)` }}
    >

      {/* Contenedor principal */}
      <div className="w-full max-w-4xl flex flex-col md:flex-row shadow-xl rounded-xl overflow-hidden bg-white">

        {/* Columna Izquierda */}
        <div className="bg-gray-200 text-gray-500 flex items-center justify-center p-0 md:p-10 w-full md:w-1/2 text-center">
          <div>
            <img
              src={`${process.env.PUBLIC_URL}/nebulox_logo_.png`}
              alt="Nebulox Parking"
              className="mx-auto h-96 md:h-72 w-auto max-w-full object-contain"
            />
            <p className=" text-lg md:text-xl">Bienvenido a nuestra plataforma</p>
          </div>
        </div>

        {/* Columna Derecha */}
        <div className="w-full md:w-1/2 flex items-center justify-center p-8">
          <div className="w-full max-w-md">
            <h2 className="text-3xl md:text-4xl font-bold text-center mb-6">
              Iniciar Sesión
            </h2>

            <form onSubmit={handleSubmit}>
              <div className="mb-4">
                <label className="block text-lg md:text-xl text-gray-700">Usuario</label>
                <div className="relative">
                  <input
                    type="text"
                    className="autofill-white w-full h-12 px-4 border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Ingresa tu usuario"
                    value={credentials.username}
                    onChange={(e) =>
                      setCredentials({ ...credentials, username: e.target.value })
                    }
                    required
                  />
                  <span
                    aria-label="Ingrese el nombre de usuario"
                    className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                  >
                    <User size={20} />
                  </span>
                </div>
              </div>

              <div className="mb-4">
                <label className="block text-lg md:text-xl text-gray-700">Contraseña</label>

                <div className="relative">
                  <input
                    type={showPassword ? "text" : "password"}
                    className="autofill-white w-full h-12 px-4 pr-12 border rounded-lg bg-white focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="Ingresa tu contraseña"
                    value={credentials.password}
                    onChange={(e) =>
                      setCredentials({ ...credentials, password: e.target.value })
                    }
                    required
                  />
                  <button
                    type="button"
                    aria-label={showPassword ? "Ocultar contraseña" : "Mostrar contraseña"}
                    onClick={() => setShowPassword(!showPassword)}
                    className="absolute inset-y-0 right-3 flex items-center text-gray-500 hover:text-gray-700"
                  >
                    {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
                  </button>
                </div>
              </div>

              {error && (
                <p className="text-red-600 text-center mb-3 text-sm">{error}</p>
              )}

              <div className="mb-4 h-12">
                <GradientButton type="submit" disabled={loading} className="login-gradient-button h-full w-full">
                {loading ? (
                  <>
                    <svg
                      className="animate-spin h-5 w-5 mr-2 text-blue-500"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      />
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                      />
                    </svg>
                    Iniciando...
                  </>
                ) : (
                  'Iniciar Sesión'
                )}
              </GradientButton>
              </div>

              <div className="login-account-links">
                <button type="button" className="login-text-link">
                  Restablecer contraseña
                </button>
                <Link to="/signup" className="login-text-link">
                  Registrarse
                </Link>
              </div>
            </form>
          </div>
        </div>

      </div>
    </div>
  );
};

export default Login;
